<script setup lang="ts">
import { computed } from 'vue';
import { useSystemInfo } from '#layers/base/stores/system-info';

/** Matches git's own abbreviated-sha default. */
const SHORT_REVISION_LENGTH = 7;

/** What the engine reports when it was built without git metadata, e.g. from a source tarball. */
const UNKNOWN_REVISION = 'unknown';

const systemInfo = useSystemInfo();

/** Empty until `/system/info` has been probed authenticated. */
const summary = computed(() => {
	const { version, revision } = systemInfo;

	if (!version) return '';

	if (!revision || revision === UNKNOWN_REVISION) return `v${version}`;

	return `v${version} · ${revision.slice(0, SHORT_REVISION_LENGTH)}`;
});
</script>

<template>
	<!-- `ps-1` lines the version up with the nav item icons: the footer's px-4 against their px-3 + px-2. -->
	<span v-if="summary" class="ps-1 text-[10px] text-dimmed">
		{{ summary }}
	</span>
</template>
